import React, { Component } from "react";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styles from "./cmsConnectorSensorTools.module.scss";
import { withDevices } from "../../../shared/containers/containerDevices";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import CmsColibrations from "./CmsColibrations";
import Scrollbars from "react-custom-scrollbars-2";
import CmsConnectedSensorChartWrapper from "./CmsConnectedSensorChartWrapper";
import DataAnalyse from "./DataAnalyse/DataAnalyse";

class CmsConnectedSensorsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectId: null,
    };
  }

  getMarkerTitle(value) {
    const { currentDevice, protocolMarkers } = this.props;

    const markerData = protocolMarkers.protocolMarkers
      .filter((x) => {
        return x.value === currentDevice.type;
      })[0]
      .markers.filter((marker) => {
        return marker.value === value;
      })[0];

    if (markerData === undefined) {
      return (
        <span>
          <b style={{ color: "red" }}>"НЕИЗВЕСТНЫЙ МАРКЕР"</b>
        </span>
      );
    }

    return (
      <span>
        <b>{markerData.code}:</b> {markerData.title}
      </span>
    );
  }

  onRowClick(selectId) {
    this.setState({ selectId });
  }

  onDeleteIconClick() {
    this.setState({ confirmpanelIsOpen: true });
  }

  onDeleteButtonHandleClick() {
    const { onDeleteConnectedSensor } = this.props;
    const { selectId } = this.state;
    onDeleteConnectedSensor({ id: selectId });
    this.setState({ confirmpanelIsOpen: false, selectId: null });
  }

  getListConnectedSensors() {
    const { currentDevice } = this.props;
    const { selectId, confirmpanelIsOpen } = this.state;

    if (confirmpanelIsOpen === true) {
      return null;
    }

    return (
      <div className={styles.listContainer}>
        <div>
          <div className={styles.itemContainer}>
            <div className={styles.rowTitle}>НАИМЕНОВАНИЕ</div>
            <div className={styles.rowMarker}>МАРКЕР ВХОДА </div>
            <div className={styles.rowDivider}>ДЕЛИТЕЛЬ</div>
            <div className={styles.rowMask}>МАСКА</div>
            <div className={styles.rowTerm}>СМЕЩЕНИЕ</div>
            <div className={styles.rowSeparatedItem}>№ ЭЛЕМЕНТА</div>
          </div>
        </div>

        <Scrollbars ref="scrollbar" style={{ height: 150 }} autoHide={false}>
          {currentDevice.connectedSensors.map((connectedSensor) => {
            return (
              <div
                key={connectedSensor.id}
                className={connectedSensor.id === selectId ? styles.itemActiveContainer : styles.itemContainer}
                onClick={this.onRowClick.bind(this, connectedSensor.id)}
              >
                <div className={styles.rowTitle}>
                  <TooltipWrapper title={`Удалить датчик`} position="right">
                    <div onClick={this.onDeleteIconClick.bind(this)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </div>
                  </TooltipWrapper>
                  {connectedSensor.sensor.title}
                </div>
                <div className={styles.rowMarker}>{this.getMarkerTitle(connectedSensor.deviceInPut.marker)}</div>
                <div className={styles.rowDivider}>{connectedSensor.deviceInPut.divider}</div>
                <div className={styles.rowMask}>{connectedSensor.deviceInPut.mask}</div>
                <div className={styles.rowTerm}>{connectedSensor.deviceInPut.term}</div>
                <div className={styles.rowSeparatedItem}>{connectedSensor.deviceInPut.separatedItem}</div>
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }

  render() {
    const { currentDevice } = this.props;
    const { selectId, confirmpanelIsOpen } = this.state;

    const selectedItme = currentDevice.connectedSensors.filter((x) => {
      return x.id === selectId;
    })[0];

    return (
      <div>

        <div className={styles.cmsConnectedSendorListContainer}>
          {selectId !== null && confirmpanelIsOpen ? (
            <div className={styles.deleteConfirmPanel}>
              <div>Удалить {selectedItme.sensor.title}?</div>
              <div>
                <ButtonPrimary handleClick={this.onDeleteButtonHandleClick.bind(this)} title="Да" />
              </div>
              <div>
                <ButtonPrimary
                  handleClick={() => {
                    this.setState({ confirmpanelIsOpen: false });
                  }}
                  title="Нет"
                />
              </div>
            </div>
          ) : null}
          {this.getListConnectedSensors()}

          <CmsColibrations key={selectId} selectId={selectId} />
        </div>

        {/*  <CmsConnectedSensorChartWrapper /> */}
      </div>
    );
  }
}

export default withDevices(withCurrentDevices(CmsConnectedSensorsList));
